import React from "react";
import { CheckIcon } from "lucide-react";
import { PageFan } from "./PageFan";
import { PurchaseButton } from "./PurchaseButton";
import { Daisy } from "./decor/Daisy";
import { LeafSprig } from "./decor/LeafSprig";
import { offerItems } from "../data/landing";
import { offer, productVisuals } from "../data/offer";
export function OfferSection() {
  return <section id="offre" className="relative overflow-hidden bg-tangerine-light" data-id="element-166" data-mp="dfyfqr1u3mwh">
      <LeafSprig className="pointer-events-none absolute -left-4 top-10 w-20 md:w-24" data-id="element-167" data-mp="icynd6ec0xpp" />
      <Daisy className="pointer-events-none absolute right-6 top-8 w-10" data-id="element-168" data-mp="md8r0cenjc1e" />
      <div className="mx-auto max-w-5xl px-4 py-16 md:px-5 md:py-24" data-id="element-169" data-mp="rey3lwhivxrl">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[2rem] font-bold leading-[1.12] text-royal md:text-5xl md:leading-[1.08]" data-id="element-170" data-mp="wcr90nb04nqt">
          Offrez à votre famille{" "}
          <span className="text-tangerine" data-id="element-171" data-mp="2t7m6g4q98j6u">de précieux moments de foi.</span>
        </h2>

        <div className="mt-10 overflow-hidden rounded-[2.25rem] border-[5px] border-tangerine bg-white md:mt-14 md:grid md:grid-cols-[0.95fr_1.05fr]" data-id="element-172" data-mp="2y67bchggbr1m">
          <div className="flex items-center bg-sun-light px-6 pb-14 pt-10 md:px-8" data-id="element-173" data-mp="xvquty2ihcef">
            {productVisuals.offerMockup ? <img src={productVisuals.offerMockup} alt="Tout le contenu du Méga Pack" className="mx-auto w-full" data-id="element-174" data-mp="sxyqu5oldztv" /> : <PageFan showTagline={false} data-id="element-175" data-mp="1lll64b76mswk" />}
          </div>

          <div className="p-6 md:p-10" data-id="element-176" data-mp="1gocnyam1aovb">
            <p className="w-fit rounded-full bg-royal-light px-3 pb-0.5 pt-1 font-display text-xs font-bold tracking-[0.14em] text-royal" data-id="element-177" data-mp="1gl70ezt1zv1p">
              OFFRE UNIQUE
            </p>
            <h3 className="mt-3 font-display text-[1.75rem] font-extrabold leading-none text-royal md:text-[2.1rem]" data-id="element-178" data-mp="17mbrhfymk6up">
              LE MÉGA PACK <span className="text-tangerine" data-id="element-179" data-mp="3scu4i5k819tx">COMPLET</span>
            </h3>

            <ul className="mt-6 space-y-3" data-id="element-180" data-mp="3sex49hb6ehbu">
              {offerItems.map(item => <li key={item} className="flex gap-3 text-cocoa" data-id="element-181" data-mp="3tusp4i777pt5">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-leaf" data-id="element-182" data-mp="2mn8zodllr5n">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-183" data-mp="3ksjjo6qsemmm" />
                  </span>
                  <span className="font-bold leading-snug" data-id="element-184" data-mp="3owzmfz53tdxm">{item}</span>
                </li>)}
            </ul>

            <div className="my-7 border-t-[3px] border-dashed border-tangerine/30" data-id="element-185" data-mp="3fu89tw0hsc4e" />

            <div className="text-center" data-id="element-186" data-mp="3fw1i1fqr74ei">
              <p className="font-display text-6xl font-extrabold leading-none text-royal md:text-7xl" data-id="element-187" data-mp="316ddm5n9zpmk">
                {offer.price}
              </p>
              <p className="mt-2 font-display text-base font-bold uppercase tracking-widest text-tangerine-dark" data-id="element-188" data-mp="3622fwgqojkmk">
                Paiement unique
              </p>
            </div>

            <PurchaseButton label="Oui, je veux le Méga Pack" className="mt-6" data-id="element-189" data-mp="2x2xhrbj15tax" />

            <p className="mt-4 text-center text-xs font-semibold leading-relaxed text-cocoa-soft md:text-sm" data-id="element-190" data-mp="2diqctt9yzj1a">
              Format numérique • Fichiers PDF à télécharger et à imprimer • Garantie 7 jours
            </p>
          </div>
        </div>
      </div>
    </section>;
}